export const INTACCT_LOGIN_REQUEST = 'INTACCT_LOGIN_REQUEST';
export const INTACCT_LOGIN_REQUEST_FAILURE = 'INTACCT_LOGIN_REQUEST_FAILURE';
export const INTACCT_LOGIN_REQUEST_SUCCESS = 'INTACCT_LOGIN_REQUEST_SUCCESS';

export const INTACCT_SYNC_REQUEST = 'INTACCT_SYNC_REQUEST';
export const INTACCT_SYNC_REQUEST_FAILURE = 'INTACCT_SYNC_REQUEST_FAILURE';
export const INTACCT_SYNC_REQUEST_SUCCESS = 'INTACCT_SYNC_REQUEST_SUCCESS';
export const INTACCT_SYNC_REQUEST_PROGRESS = 'INTACCT_SYNC_REQUEST_PROGRESS';

export const GET_SYNC_STATUS_REQUEST = 'GET_SYNC_STATUS_REQUEST';
export const GET_SYNC_STATUS_REQUEST_FAILURE = 'GET_SYNC_STATUS_REQUEST_FAILURE';
export const GET_SYNC_STATUS_REQUEST_SUCCESS = 'GET_SYNC_STATUS_REQUEST_SUCCESS';
export const GET_SYNC_STATUS_REQUEST_PROGRESS = 'GET_SYNC_STATUS_REQUEST_PROGRESS';

export const GET_COMPANY_SYNC_STATUS_REQUEST = 'GET_COMPANY_SYNC_STATUS_REQUEST';
export const GET_COMPANY_SYNC_STATUS_REQUEST_FAILURE = 'GET_COMPANY_SYNC_STATUS_REQUEST_FAILURE';
export const GET_COMPANY_SYNC_STATUS_REQUEST_SUCCESS = 'GET_COMPANY_SYNC_STATUS_REQUEST_SUCCESS';
export const GET_COMPANY_SYNC_STATUS_REQUEST_PROGRESS = 'GET_COMPANY_SYNC_STATUS_REQUEST_PROGRESS';
